import request from '@/utils/request'

let Fl_classifyApi = {

  /*分类列表*/
  list(data) {
    return request._post('/shop/plus.fl_classify.Index/index', data);
},
/*添加分类*/
add(data) {
    return request._post('/shop/plus.fl_classify.Index/add', data);
},
/*修改分类*/
edit(data) {
    return request._post('/shop/plus.fl_classify.Index/edit', data);
},
/*删除分类*/
del(data) {
    return request._post('/shop/plus.fl_classify.Index/del', data);
},
/*分类详情*/
detail(data) {
  return request._post('/shop/plus.fl_classify.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.fl_classify.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.fl_classify.Setting/getSetting', data, errorback);
    },
}
export default Fl_classifyApi;



// WEBPACK FOOTER //
// ./src/api/fl_classify.js